<template>
  <div>{{label}} {{dots.join('')}}</div>
</template>

<script>
export default {
  data() {
    return {
      dots: [],
      maxDots: 5,
      intervalRef: null
    }
  },
  mounted() {
    this.intervalRef = setInterval(this.onInterval, 200)
  },
  methods: {
    onInterval() {
      
      if(this.dots.length < this.maxDots) {
        this.dots.push('.')
      } else {
        this.dots = []
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalRef)
  },
  computed: {
    label() {
      return wp_variables.search.search_pending_label
    }
  }
}
</script>